import { defineMessages } from "react-intl";

const messages = defineMessages({
    labeled: {
        id: "planCard.labeled",
    },
    publicationInProgress: {
        id: "planCard.publicationInProgress",
    },
    listed: {
        id: "planCard.listed",
    },
    experience: {
        id: "plan.experience",
    },
    solution: {
        id: "homework.solution",
    }
});

export default messages;
